import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from '../../../../../store/modules/ModalActions';
import { getElementID } from '../../../../../utils/HTMLUtils';
import { Col } from '../../../../../components/Col';
import { CustomButton } from '../../../../../components/CustomButton';
import { GenericModal } from '../../../../../components/GenericModal';
import SaveIcon from '../../../../../components/Icons/SaveIcon';
import { Row } from '../../../../../components/Row';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { changeContratoEntePrivadoEditingValue } from '../../../../../store/modules/ContratosEntePrivadoActions';
import GenericDados from './GenericDados';
import styles from './CadastroAnexoIModal.scss';
import CustomCurrencyField from '../../../../../components/CustomCurrencyField/CustomCurrencyField';

const rootClassName = styles.rootClassName;
const rootElementId = 'cadastro-atividade-modal';

const MAX_SIZE_INPUTS = 200;

const INITIAL_STATE = {
  index: -1,
  atividade: '',
  atividadeChanged: false,
  custo: '',
  custoChanged: false,
  id: 0,
  atividadeArr: [],
};

class CadastroAtividadesModal extends GenericDados {
  constructor(props) {
    super(props);

    this.state = {
      ...INITIAL_STATE,
      ...(this.props.atividade || {}),
      atividadeArr: this.props.contratosEntePrivado.contratoEditing.atividades,
    };
  }

  toClose = () => {
    this.props.closeModal(this.props.modalKey);
  };

  toCancel = () => {
    if (typeof this.props.cancelCallback === 'function') {
      this.props.cancelCallback();
    }
    this.toClose();
  };

  toConfirm = () => {
    this.props.savedCallback({
      index: this.state.index,
      atividade: this.state.atividade,
      custo: this.state.custo,
      id: this.state.id,
    });
    this.toClose();
  };

  atividadeIsValid() {
    if (this.state.atividade !== INITIAL_STATE.atividade) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
      };
    }
  }

  custoIsValid() {
    if (this.state.custo !== INITIAL_STATE.custo) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
      };
    }
  }

  buttomIsDisabled() {
    if (this.atividadeIsValid().status && this.custoIsValid().status) {
      if (
        this.state.atividade === '' ||
        this.state.atividade === null ||
        this.state.custo === 0 ||
        this.state.custo === null
      ) {
        return {
          status: true,
        };
      }
      return {
        status: false,
      };
    } else {
      return {
        status: true,
      };
    }
  }

  render() {
    return (
      <GenericModal
        id={rootElementId}
        onClose={this.toCancel}
        DialogProps={{
          maxWidth: 'sm',
          disableBackdropClick: true,
          disableEscapeKeyDown: true,
        }}
        title={this.props.languageValues.cadastroAtividadeModalTitle}
        footerContent={
          <Row>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomButton
                id={getElementID(rootElementId, 'cancel')}
                theme='pufvYellow'
                className={rootClassName + '-cancel-button'}
                label={this.props.languageValues.cancelButton}
                onClick={this.toCancel}
              />
            </Col>
            <Col className={rootClassName} cols={[12, 12, 6, 6, 6]}>
              <CustomButton
                id={getElementID(rootElementId, 'confirm')}
                theme='sicrediGreen'
                className={rootClassName + '-confirm-buttom'}
                label={this.props.languageValues.cadastroAtividadeButtomLabel}
                rightIcon={<SaveIcon />}
                onClick={this.toConfirm}
                disabled={this.buttomIsDisabled().status}
              />
            </Col>
          </Row>
        }
      >
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'atividade')}
              label={this.props.languageValues.atividadeLabel}
              name='atividade'
              value={this.state.atividade}
              onChange={(event) => {
                this.setState({
                  atividade: event.target.value,
                  atividadeChanged: true,
                });
              }}
              counter={true}
              maxSize={MAX_SIZE_INPUTS}
              error={
                this.state.atividadeChanged && !this.atividadeIsValid().status
              }
              helperText={
                this.state.atividadeChanged && !this.atividadeIsValid().status
                  ? this.props.languageValues.emptyAtiviade
                  : ''
              }
            />
            <CustomCurrencyField
              id={getElementID(rootElementId, 'custo')}
              label={this.props.languageValues.custoLabel}
              name='custo'
              value={this.state.custo}
              onChange={(value) => {
                this.setState({
                  custo: value,
                  custoChanged: true,
                });
              }}
              error={this.state.custoChanged && !this.custoIsValid().status}
              helperText={
                this.state.custoChanged && !this.custoIsValid().status
                  ? this.props.languageValues.emptyCusto
                  : ''
              }
            />
          </Col>
        </Row>
      </GenericModal>
    );
  }
}

CadastroAtividadesModal.propTypes = {
  atividade: PropTypes.object,
  savedCallback: PropTypes.func.isRequired,
  cancelCallback: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratosEntePrivado: state.contratosEntePrivado,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal,
      changeContratoEntePrivadoEditingValue,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CadastroAtividadesModal);
